<!-- stephanrauh/pdf.js#14 modified by ngx-extended-pdf-viewer - the eraser -->
<!-- Icon "ink_eraser": Material Symbols by Google (https://github.com/google/material-design-icons), Apache License 2.0 -->
<pdf-shy-button
  title="Erase"
  primaryToolbarId="primaryEditorEraser"
  [cssClass]="show() | responsiveCSSClass : 'hiddenTinyView'"
  l10nId="pdfjs-editor-eraser-button"
  l10nLabel="pdfjs-editor-eraser-button-label"
  ariaHasPopup="true"
  ariaControls="editorEraserParamsToolbar"
  [order]="4060"
  [action]="onClick"
  [toggled]="isSelected"
  [closeOnClick]="true"
  [disabled]="disable()"
  image="<svg aria-hidden='true' focusable='false' width='20px' height='20px' viewBox='0 -960 960 960' xmlns='http://www.w3.org/2000/svg' fill='currentColor'><path d='M690-240h190v80H610l80-80Zm-500 80-85-85q-23-23-23.5-57t22.5-58l440-456q23-24 56.5-24t56.5 23l199 199q23 23 23 57t-23 57L520-160H190Zm296-80 314-322-198-198-442 456 64 64h262Zm-6-240Z'/></svg>"
>
</pdf-shy-button>
<!-- stephanrauh/pdf.js#14 end of modification by ngx-extended-pdf-viewer -->
